module.exports = "/deep/ .table-responsive {\n  max-height: 500px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/dashboards/components/user-list-widget/user-list-widget.component.scss
// module id = ./libs/chassis-core/src/app/dashboards/components/user-list-widget/user-list-widget.component.scss
// module chunks = main